export default __webpack_public_path__ + "static/media/shieldofbrilliance.fc7fc49b.png";